import React from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, Stack } from '@mui/material';
import { PortalConfigDealer, PortalManagementFormValuesDealer } from '../types';
import { VendorProfile } from '@trnsact/trnsact-shared-types';
import { SwitchField } from 'components/form';

interface Props {
  isLoading: boolean;
  vendorProfile: VendorProfile;
  portalConfigurationConfig: PortalConfigDealer;
  onConfirm: (configuration: PortalManagementFormValuesDealer) => Promise<void>;
}

export const PortalManagementFormDealer = ({
  isLoading,
  vendorProfile,
  portalConfigurationConfig,
  onConfirm,
}: Props) => {
  const { control, handleSubmit } = useForm<PortalManagementFormValuesDealer>({
    defaultValues: {
      multiLocationManagement: !!vendorProfile.multiLocationManagement,
      enhancedStagesFlow: !!portalConfigurationConfig.enhancedStagesFlow,
      messagingModule: !!portalConfigurationConfig.messagingModule,
      calendarModule: !!portalConfigurationConfig.calendarModule,
    },
  });

  return (
    <Box sx={{ display: 'grid', gridTemplateRows: '1fr auto', gap: '1rem', height: '100%' }}>
      <Stack gap="0.5rem">
        <SwitchField label="Multi-location management" control={control} name="multiLocationManagement" />
        <SwitchField label="Enhanced Stages Flow" control={control} name="enhancedStagesFlow" />
        <SwitchField label="Messaging Module" control={control} name="messagingModule" />
        <SwitchField label="Calendar Module" control={control} name="calendarModule" />
      </Stack>
      <Box>
        <Button loading={isLoading} variant="contained" onClick={handleSubmit(onConfirm)} size="small">
          Save
        </Button>
      </Box>
    </Box>
  );
};
